import React, { useEffect } from "react";
import { useAuth } from "../../context/contextAuth";
import { useProfile } from "../../context/contextProfile";
import { useDesign } from "../../context/contextDesign";
import { useTSContext } from "../../context/Dashboard/contextTScore";
import { useWeb } from "../../context/Dashboard/contextWeb";
import { useNetwork } from "../../context/Dashboard/contextNetwork";
// import { useAwsConfig } from "../../context/Dashboard/aws/contextConfig";
import { useAwsIp } from "../../context/Dashboard/aws/contextIp";
import { useAwsUrl } from "../../context/Dashboard/aws/contextUrl";
import { useAzureConfig } from "../../context/Dashboard/azure/contextConfig";
import { useAzureIp } from "../../context/Dashboard/azure/contextIp";
import { useAzureUrl } from "../../context/Dashboard/azure/contextUrl";
import { useMalware } from "../../context/Dashboard/contextMalware";
import { useDarkweb } from "../../context/Dashboard/contextDarkweb";
import { usePayment } from "../../context/contextPayment";
import ScanView from "../../layouts/main/View";
import PrimaryData from "../../layouts/main/PrimaryData";
import Loader2 from "../../components/loaders/Loader-2";

const Dashboard = () => {
  const { signIn, user } = useAuth();
  const { 
    initData: initTSData,
    loading, setLoading
  } = useTSContext();
  const { initData: initProfileData } = useProfile();
  const { initData: initWebData } = useWeb();
  const { initData: initNetworkData } = useNetwork();
  // const { initData: initAWSConfigData } = useAwsConfig();
  const { initData: initAWSIpData } = useAwsIp();
  const { initData: initAWSUrlData } = useAwsUrl();
  const { initData: initAzureConfigData } = useAzureConfig();
  const { initData: initAzureIpData } = useAzureIp();
  const { initData: initAzureUrlData } = useAzureUrl();
  const { initData: initMalwareData } = useMalware();
  const { initData: initDarkwebData } = useDarkweb();
  const { initData: initPaymentData } = usePayment();  
  const { bHeightVal } = useDesign();

  useEffect(() => {
    if (signIn) initTSData();
  }, [signIn]);
  
  useEffect(() => {
    const loadAllData = async () => {
      try {
        setLoading(true);
        await Promise.all([
          initProfileData(),
          initWebData(),
          initNetworkData(),
          // initAWSConfigData(),
          initAWSIpData(),
          initAWSUrlData(),
          initAzureConfigData(),
          initAzureIpData(),
          initAzureUrlData(),
          initMalwareData(),
          initDarkwebData(),
          initPaymentData(),
        ]);
      } catch (error) {
        console.error("❌ Error initializing dashboard data:", error);
      } finally {
        setLoading(false);
      }
    };

    loadAllData();
  }, []);

  return (
    <>
      {loading ? (
        <Loader2 />
      ) : (
        <div className="default-dashboard">
          <div className="d-flex flex-row overflow-y-auto"
            style={{height: bHeightVal}}>
            <ScanView />
            <PrimaryData />
          </div>
        </div>
      )}
    </>
  );
};

export default Dashboard;
